/**
 * How much room the image is drawn into. The two larger sizes are the card artwork, drawn at two
 * levels of detail; the smallest is a row rather than a card, where that artwork reads as a smudge
 * and the tool's own icon stands in for it.
 */
export const GENERATION_TOOL_CARD_IMAGE_SIZE = {
  large: 'large',
  medium: 'medium',
  small: 'small',
} as const;

export type GenerationToolCardImageSize =
  (typeof GENERATION_TOOL_CARD_IMAGE_SIZE)[keyof typeof GENERATION_TOOL_CARD_IMAGE_SIZE];
